/*
 * @Author: Teemo Ding
 * @Date: 2021-08-19 10:38:39
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-10 17:30:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogoManagement/index.tsx
 */
import { Skeleton } from '@/src/components/Antd';
import CommonHeader from '@/src/components/CommonHeader';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import useBreadCrumbData from '@/src/pages/SalesCannelVersion/Hooks/useBreadCrumbData';
import { getLogo, saveLogo } from '@/src/request/settings/logoManagement';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Form, message } from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import LogoWrapper from './LogoWrapper';
import css from './css.module.less';

const permissions = (uuid: string) => {
  const view_logo_management_settings = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelLogoManagement,
        operation: EnumOperation.view_logo_management_settings,
        uuid,
      }),
    ],
  });
  const edit_logo_management = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelLogoManagement,
        operation: EnumOperation.edit_logo_management,
        uuid,
      }),
    ],
  });

  return {
    view_logo_management_settings,
    edit_logo_management,
  };
};

const SalesChannelLogoManagement = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();
  const { view_logo_management_settings, edit_logo_management } =
    permissions(uuid);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const [formData, setFormData] = useState();
  const { loading: breadCrumbLoading, breadcrumbData } = useBreadCrumbData({
    lastSecond: getI18n('general.sider.settings'),
    lastOne: getI18n('salesChannelLogoManagement.index.logoManagement'),
  });

  useEffect(() => {
    if (view_logo_management_settings) {
      getLogo(uuid).then((data) => {
        setFormData(data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);
  const onGoBackClick = () => {
    history.push(`/salesChannel/settings/${uuid}`);
  };

  const onValuesChange = () => {
    setHasModified(true);
  };

  const handleSubmit = (values) => {
    values.salesChannelUuid = uuid;
    values.uuid = _.get(formData, 'uuid', '');
    saveLogo(values).then((data) => {
      message.success(getI18n('general.savesuccess'));
      setHasModified(false);
    });
  };

  return (
    <Skeleton loading={loading || breadCrumbLoading} active>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <CommonHeader
        breadcrumbData={breadcrumbData}
        onSaveDisable={!hasModified}
        onSubmit={() => form.submit()}
        onDiscard={onGoBackClick}
        onGoBackClick={onGoBackClick}
      />
      <Form
        name={'languageSetting'}
        form={form}
        onFinish={handleSubmit}
        initialValues={formData}
        onValuesChange={onValuesChange}
        className={css.formClass}>
        <LogoWrapper
          keyName='loginLogo'
          sectionTitle={getI18n(
            'salesChannelLogoManagement.index.loginSignupPageLogo',
          )}
          sectionDescription={`${getI18n(
            'salesChannelLogoManagement.index.recommendeddimension',
          )}  560*160 px`}
          disabled={!edit_logo_management}
        />
        <LogoWrapper
          keyName='packSlipLogo'
          sectionTitle={getI18n(
            'salesChannelLogoManagement.index.packingSlipLogo',
          )}
          sectionDescription={`${getI18n(
            'salesChannelLogoManagement.index.recommendeddimension',
          )}  160*160 px`}
          disabled={!edit_logo_management}
        />
        <LogoWrapper
          keyName='invoiceLogo'
          sectionTitle={getI18n('salesChannelLogoManagement.index.invoiceLogo')}
          sectionDescription={`${getI18n(
            'salesChannelLogoManagement.index.recommendeddimension',
          )}  160*160 px`}
          disabled={!edit_logo_management}
        />
      </Form>
    </Skeleton>
  );
};

export default SalesChannelLogoManagement;
